import { create } from 'zustand';

type TextExtraction = typeof import('./text-extraction');

let loaded: TextExtraction | undefined;

const useExtractionState = create<{ isSettled: boolean }>()(() => ({ isSettled: false }));

function selectIsSettled(state: { isSettled: boolean }) {
  return state.isSettled;
}

/** Never rejects: a failed download leaves read-aloud on the raw text, and formatting unaffected. */
export async function loadTextExtraction(): Promise<void> {
  try {
    loaded = await import('./text-extraction');
  } catch {}
  useExtractionState.setState({ isSettled: true });
}

// speak() must stay synchronous (iOS only lets audio start inside the click), so it can't await
// the module. The read-aloud button waits for this instead (useTextExtractionSettled).
export function toTtsText(markdown: string): string {
  return loaded ? loaded.partToText(markdown) : markdown;
}

export function useTextExtractionSettled(): boolean {
  return useExtractionState(selectIsSettled);
}
